import enUS from './en-us'
import it from './it-it'

export default {
  'en-us': enUS,
  'it-it': it
}
